import { isPalmettoFinanceUser } from '@/components/auth/RequirePricingAdminUser';
import { ReactNode } from 'react';

import { UserPermissions } from 'types';

import { useAuth } from './authProvider';

export const RequirePayoutsAccountingApproverUser = ({ children }: { children: ReactNode }) => {
  const { claims } = useAuth();
  const isPalmettoFinance = isPalmettoFinanceUser(claims);
  const isLightReachAccountingApprover = claims?.permissions?.includes(UserPermissions.lightReachAccountingApprover);
  return isPalmettoFinance && isLightReachAccountingApprover ? <>{children}</> : null;
};
